const [medGrey, lightGrey, darkGrey] = [0x5a5a5a, 0xd3d3d3, 0x242424];
const [
  synthSunsetYellow,
  synthSunsetOrange,
  synthSunsetMagenta,
  synthSunsetPink,
  synthSunsetViolet,
] = [0xffd319, 0xff901f, 0xff2975, 0xf222ff, 0x8c1eff];

const [
  synthCyberLightBlue,
  synthCyberPink,
  synthCyberDarkBlue,
  synthCyberPurple,
  synthCyberPaleBlue,
  synthCyberBlack,
] = [0x0b4abd, 0xde41cd, 0x072c94, 0xb16eb5, 0x93c8c4, 0x2c2e3b];
// --color-1:	#8a04ed;
// --color-2:	#ef9af2;
// --color-3:	#240c76;
// --color-4:	#570296;
// --color-5:	#831187;
// --color-6:	#0c0c0c;

const anotherLightPink = 0xef9af2;

const [themePurple, themeBackground] = [0xcf7bc1, 0x262335];

export {
  darkGrey,
  lightGrey,
  medGrey,
  synthCyberDarkBlue,
  synthCyberBlack,
  synthCyberLightBlue,
  synthCyberPaleBlue,
  synthCyberPink,
  synthCyberPurple,
  synthSunsetMagenta,
  synthSunsetOrange,
  synthSunsetPink,
  synthSunsetViolet,
  synthSunsetYellow,
  themeBackground,
  themePurple,
  anotherLightPink,
};
